<template>
  <!-- 最新消息首页 -->
  <div class="container">
    <content-template>
      <template slot="left">最新消息</template>
      <template slot="right">
        <li>
          <router-link to="new-message">全部</router-link>
        </li>
        <li><router-link to="events">賽事動態</router-link></li>
        <li><a class="is-check" >其他活動</a></li>
      </template>
      <template slot="banner">
        <img src="./banner.png" class="top-banner" alt="">
      </template>
      <template slot="content">
        <div class="circle-line hidden-xs col-sm-1">
          <template v-if="lineNum >= 1">
            <div class="first-circle"></div>
          </template>
          <template v-for="i in lineNum-1">
            <div class="line"></div>
            <div class="white-circle"></div>
          </template>
        </div>

        <template v-for="article in articles">
          <div class="news col-xs-12 col-sm-11 ">
            <template v-if="article.more.thumbnail">
              <img :src="article.more.thumbnail">
            </template>
            <template v-else>
              <img src="@/assets/thumbnail.png">
            </template>
            <div class="news-content">
              <span>{{article.published_time}}</span>
              <router-link :to="{path: 'article', query: {id:article.id}}">    <!-- 路由。。。指向新闻详细页面 -->
                <h4>{{article.post_title}}</h4>
                <div class="news-desc hidden-xs hidden-sm">{{article.post_excerpt}}</div>
              </router-link>
            </div>
          </div>
        </template>

        <template v-if="totalPages >= 1">
          <mo-paging
            :totalPages="totalPages"
            v-on:get-list="getActivity">
          </mo-paging>
        </template>

      </template>
    </content-template>
  </div>
</template>
<script>
import contentTemplate from '../contentTemplate'
import MoPaging from '../pages'

export default {
  components: {
    'content-template': contentTemplate,
    MoPaging
  },
  data () {
    return {
      current: 1,
      TColor: {color: '#5571EC'},
      type: 0,            // 哪个分类的文章
      lineNum: 1,           //多少個新聞
      pageSize: 10, //每页显示10条数据
      currentPage: 1, //当前页码
      count: 0, //总记录数
      totalPages: 0,	//总页数
      articles: []    // 文章数组
    }
  },
  methods: {
    // 获取文章总数量
    getCount (id) {
      var that = this
      var url = this.$url + 'portal/ArticleCounts?pid=' + id
      this.$axios.get(url)
        .then(function (response) {
          if (response.data.code === 1) {
            // 总数量
            that.count = response.data.data.counts
            // 总页数
            that.totalPages = Math.ceil(that.count / that.pageSize)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 汇业杯活动
    getActivity: function (page) {
      this.type = 2
      const that = this
      this.theUrl = 'portal/lists/getCategoryPostLists?category_id=4&page=' + page + ',' + this.pageSize
      this.$axios.get(this.theUrl)
        .then(function (response) {
          that.current = 3
          if (response.data.code === 1) {
            // 文章
            that.articles = response.data.data.list
            // 文章数
            that.lineNum = that.articles.length
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  mounted: function () {
    this.getCount(4)
  }
}
</script>
<style scoped>
  .container {
    padding: 0px;
  }

  /*线条圆圈*/
  .circle-line {
    text-align: center;
  }

  /*分页*/
  .page-body {
    border: 1px solid #526ADD;
    border-radius: 100px;
  }

  .pagination li a {
    border: 0px;
    border-radius: 100px;
    cursor: pointer;
  }

  .pagination li a:hover, .pagination li a:focus {
    background: #526ADD;
    color: #ffffff;
  }

</style>



// WEBPACK FOOTER //
// src/components/newMessage/activity.vue